import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const propertiesSearchWidget = {
        isLoading: false,
        init() {
            $(document).on('click', '.search-properties-btn', this, this.send);
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

            var url = $(this).data('url');

            var urlParams = '';

            if ($('#slocation').val() != '') {
                if (urlParams == '') {
                    urlParams += '?l=' + encodeURIComponent($('#slocation').val());
                } else {
                    urlParams += '&l=' + encodeURIComponent($('#slocation').val());
                }
            }

            if ($('#sprice').val() != '') {
                if (urlParams == '') {
                    urlParams += '?p=' + encodeURIComponent($('#sprice').val());
                } else {
                    urlParams += '&p=' + encodeURIComponent($('#sprice').val());
                }
            }

			window.location = url + urlParams;
		}
    };

    if ($('.search-properties-btn').length) {
        propertiesSearchWidget.init();
    }

    const islandsSearchWidget = {
        isLoading: false,
        init() {
            $(document).on('click', '.search-islands-btn', this, this.send);
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

            var url = $(this).data('url');

            var urlParams = '';

            if ($('#slocation').val() != '') {
                if (urlParams == '') {
                    urlParams += '?l=' + encodeURIComponent($('#slocation').val());
                } else {
                    urlParams += '&l=' + encodeURIComponent($('#slocation').val());
                }
            }

            if ($('#sprice').val() != '') {
                if (urlParams == '') {
                    urlParams += '?p=' + encodeURIComponent($('#sprice').val());
                } else {
                    urlParams += '&p=' + encodeURIComponent($('#sprice').val());
                }
            }

			window.location = url + urlParams;
		}
    };

    if ($('.search-islands-btn').length) {
        islandsSearchWidget.init();
    }

    const artItemsSearchWidget = {
        isLoading: false,
        init() {
            $(document).on('click', '.search-art-items-btn', this, this.send);
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

            var url = $(this).data('url');

            var urlParams = '';

            if ($('#sartist').val() != '') {
                if (urlParams == '') {
                    urlParams += '?a=' + encodeURIComponent($('#sartist').val());
                } else {
                    urlParams += '&a=' + encodeURIComponent($('#sartist').val());
                }
            }

            if ($('#sprice').val() != '') {
                if (urlParams == '') {
                    urlParams += '?p=' + encodeURIComponent($('#sprice').val());
                } else {
                    urlParams += '&p=' + encodeURIComponent($('#sprice').val());
                }
            }

			window.location = url + urlParams;
		}
    };

    if ($('.search-art-items-btn').length) {
        artItemsSearchWidget.init();
    }

    const vehiclesSearchWidget = {
        isLoading: false,
        init() {
            $(document).on('click', '.search-vehicles-btn', this, this.send);
        },
		send(event) {
			const _this = event.data;
			event.preventDefault();

            var url = $(this).data('url');

            var urlParams = '';

            if ($('#smanufacturer').val() != '') {
                if (urlParams == '') {
                    urlParams += '?m=' + encodeURIComponent($('#smanufacturer').val());
                } else {
                    urlParams += '&m=' + encodeURIComponent($('#smanufacturer').val());
                }
            }

            if ($('#sprice').val() != '') {
                if (urlParams == '') {
                    urlParams += '?p=' + encodeURIComponent($('#sprice').val());
                } else {
                    urlParams += '&p=' + encodeURIComponent($('#sprice').val());
                }
            }

			window.location = url + urlParams;
		}
    };

    if ($('.search-vehicles-btn').length) {
        vehiclesSearchWidget.init();
    }
});
